import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SvgIcon } from '@k12/models';
import { SvgIconComponent } from '@k12/ui-primitives';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-user-record-widget',
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressBarModule, SvgIconComponent],
  templateUrl: './user-record-widget.component.html',
  styleUrls: ['./user-record-widget.component.scss']
})
export class UserRecordWidgetComponent {
  @Input() userData: unknown[] = [];
  @Input() value: string;
  @Input() title: string;
  @Input() percentage: number;
  @Input() growth: number;
  @Input() svgName: SvgIcon;
}

